export const SUPPORT_PULSE_REPORT = {
  headline: '2 threads need a reply · possible outage',
  status: 'attention',
  durationSec: 21,
  body: `**2 threads in support@ need attention.**

| Customer | Subject | Waiting | Why it was flagged |
|---|---|---|---|
| Orbit Foods | Refund for duplicate invoice INV-2291 | 3h 10m | Mentions a refund |
| Pinnacle Media | Dashboard not loading since this morning | 2h 25m | Possible outage — 2 similar reports this hour |

Every other thread (14) got a reply within 45 minutes.

Posted a heads-up to #support.`,
}
